var radioUnicId = 0

export function sale_vs_item(id, idItem) {
      let parsedId = ''

      if (idItem && idItem !== '' && idItem !== '[]') {
            const itemData = typeof idItem === 'string' ? JSON.parse(idItem) : idItem
            parsedId = itemData[0] ? itemData[0].id : ''
      }

      radioUnicId++

      return `
      <div class="line line-${id}" lineId="${id}" style="height: 36px;">
            <div class="removeLine" style="top:6px;" data-detail='{"click": [
                  {"dest":"ripple"},
                  {"dest":"multitable", "act":"removeLine"},
                  {"dest":"retail", "elem":"fullcont", "act":"calculateGrandTotal"}
            ]}'></div>

            <div class="btn-item-info" style="top:6px;" data-detail='{"click": [
                  {"dest":"ripple"},
                  {"dest":"item", "elem":"quickview", "act":"getExtraData", "idItem":"${parsedId}", "from":"retail"}
            ]}'></div>

            <div class="row pl-28">
                  <div class="c50 itemname" style="margin: 0;">
                        <div class="row">
                              <div class="c100">
                                    <div class="textfield textfield-autocomplete textfield-autocomplete-deskOne purchase_vs_itemId"
                                          id="retail_form_item_mt_${radioUnicId}" selected="[]" max="1">
                                          <input autocomplete="off" class="elem" type="text" data-detail='{
                                                "key": [
                                                      {"dest":"textfield", "act":"typing"},
                                                      {"dest":"autocomplete", "act":"typing", "entity":"purchase_vs_item", "mainFilter":["item.name","item.code","purchase.code"], "parent":"retail_form_item_mt_${radioUnicId}"}
                                                ],
                                                "click": [
                                                      {"dest":"autocomplete", "act":"click", "entity":"purchase_vs_item", "mainFilter":["item.name","item.code","purchase.code"], "parent":"retail_form_item_mt_${radioUnicId}"}
                                                ]
                                          }'>
                                          <div class="chip-cont"></div>
                                          <div class="dn otherField" data-detail='{"click": [
                                                {"dest":"retail", "elem":"fullcont", "act":"otherFieldItem", "id_ac":"${radioUnicId}"}
                                          ]}'></div>
                                    </div>
                              </div>
                        </div>
                  </div>

                  <div class="c50 itemdetail">
                        <div class="row">
                              <div class="c25">
                                    <div class="textfield textfield-disabled textfield-desk selling_type">
                                          <input autocomplete="off" class="elem" type="text" placeholder="Type" readonly tabindex="-1">
                                    </div>
                              </div>

                              <div class="c25">
                                    <div class="textfield textfield-desk qty">
                                          <input autocomplete="off" class="elem" type="number" inputmode="numeric" placeholder="Qty" step="1" min="0"
                                                data-detail='{"key": [
                                                      {"dest":"textfield", "act":"typing"},
                                                      {"dest":"retail", "elem":"fullcont", "act":"calculate_values", "id_item_ac":"${radioUnicId}", "input":"qty"},
                                                      {"dest":"retail", "elem":"key", "act":"add_line_item"}
                                                ]}'>
                                    </div>
                              </div>

                              <div class="c25">
                                    <div class="textfield textfield-desk textfield-cash price">
                                          <input autocomplete="off" class="elem" type="number" placeholder="Price" step="0.01" min="0"
                                                data-detail='{"key": [
                                                      {"dest":"textfield", "act":"typing"},
                                                      {"dest":"retail", "elem":"fullcont", "act":"calculate_values", "id_item_ac":"${radioUnicId}", "input":"price"},
                                                      {"dest":"retail", "elem":"key", "act":"add_line_item"}
                                                ]}'>
                                    </div>
                              </div>

                              <div class="c25">
                                    <div class="textfield textfield-desk textfield-cash total">
                                          <input autocomplete="off" class="elem" type="number" placeholder="Total" step="0.01" min="0"
                                                data-detail='{
                                                      "key": [
                                                            {"dest":"textfield", "act":"typing"},
                                                            {"dest":"retail", "elem":"fullcont", "act":"calculate_values", "id_item_ac":"${radioUnicId}", "input":"total"},
                                                            {"dest":"retail", "elem":"key", "act":"add_line_item"}
                                                      ],
                                                      "keyDown": [
                                                            {"dest":"retail", "elem":"key", "act":"add_line_item"}
                                                      ]
                                                }'>
                                    </div>
                              </div>
                        </div>
                  </div>

                  <div class="dn cost">
                        <input class="elem" type="text" value="0.00" readonly>
                  </div>
                  <div class="dn cogs_row_amount">
                        <input class="elem" type="text" value="0.00" readonly>
                  </div>
            </div>

            <div class="restriction" data-detail='{"click": [{"dest":"textfield", "act":"restriction"}] }'></div>
      </div>`
}
